import { useI18n } from '@/libraries/contexts/i18n-context';
import { useSwiper } from 'swiper/react';
import Button from '@/components/molecules/button/button';
import styles from './media-slider-controls.module.scss';

const MediaSliderControls = () => {
  const swiper = useSwiper();
  const { t } = useI18n();

  return (
    <div className={styles.component}>
      <Button
        aria-label={t('items.common.words.previousImage')}
        className={styles.button}
        icon="ChevronLeft"
        onClick={() => swiper.slidePrev()}
        variant="tertiary"
      />

      <Button
        aria-label={t('items.common.words.nextImage')}
        className={styles.button}
        icon="ChevronRight"
        onClick={() => swiper.slideNext()}
        variant="tertiary"
      />
    </div>
  );
};

MediaSliderControls.displayName = 'MediaSliderControls';

export default MediaSliderControls;
